module.exports = __webpack_public_path__ + "fonts/nationale-demibold.56a6199.eot";